import { createI18n } from 'vue-i18n/index'

import es from './locales/es.json'
import en from './locales/en.json'

export default createI18n({
  legacy: false,
  locale: process.env.VUE_APP_I18N_LOCALE || 'es',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    es,
    en
  },
  modifiers: {
    snakeCase: function (str)  {
      console.log(str)
      return str;
    }
  }
})
